import { CSSProperties } from 'react';

export const defaultStyle: CSSProperties = {
  minWidth: '100%',
  minHeight: '90vh',
};

export const defaultPanelStyle: CSSProperties = {
  height: '20vh',
  width: '20vw',
  position: 'absolute',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  padding: 15,
  top: 70,
  left: 10,
};

export const panelPositions: any = {
  'top-left': {
    top: 70,
    left: 10,
  },
  'top-right': {
    top: 70,
    right: 10,
  },
  'bottom-left': {
    bottom: 90,
    left: 10,
  },
  'bottom-right': {
    bottom: 70,
    right: 10,
  },
};

export const positioningStyle: any = {
  'top-left': {
    top: 70,
    left: 10,
  },
  'top-right': {
    top: 70,
    right: 10,
  },
  'bottom-left': {
    bottom: 90,
    left: 10,
  },
  'bottom-right': {
    bottom: 70,
    right: 10,
  },
};
